export default "__VITE_ASSET__Cx8QfURA__"